(function () {
  const triggerAutoplay = (video) => {
    if (!video) return;

    // Enforce attributes required by iOS, Chrome, and Safari
    video.muted = true;
    video.defaultMuted = true;
    video.setAttribute('muted', '');
    video.setAttribute('playsinline', '');
    video.setAttribute('autoplay', '');

    const playPromise = video.play();
    if (playPromise !== undefined) {
      playPromise.catch((err) => {
        // Fallback retry if first call triggered mid-render
        video.muted = true;
        video.play().catch((e) => {
          console.warn('Autoplay blocked or waiting on user gesture:', e);
        });
      });
    }
  };

  const handleMediaLoad = () => {
    // 1. Click deferred media poster buttons to force theme to mount the player
    const posters = document.querySelectorAll('button.deferred-media__poster');
    posters.forEach((btn) => btn.click());

    // 2. Play any existing video element
    const existingVideo = document.querySelector('.deferred-media video, video');
    if (existingVideo) {
      triggerAutoplay(existingVideo);
    }
  };

  // Observe DOM additions so we catch the <video> the moment Shopify renders it
  const observer = new MutationObserver((mutations) => {
    // Check if poster appeared
    const poster = document.querySelector('button.deferred-media__poster');
    if (poster && poster.getAttribute('aria-hidden') !== 'true') {
      poster.click();
    }

    // Check if video element appeared
    const video = document.querySelector('.deferred-media video, video');
    if (video) {
      triggerAutoplay(video);
      // Once playing or loaded, disconnect to prevent redundant checks
      if (!video.paused || video.readyState >= 2) {
        observer.disconnect();
      }
    }
  });

  observer.observe(document.documentElement, {
    childList: true,
    subtree: true,
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', handleMediaLoad);
  } else {
    handleMediaLoad();
  }
})();